
import { EventMonitoringActions, EventMonitoringActionTypes } from '../actions/event-monitoring.actions';
import {Events} from '../../../models/events';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: Events[];
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: []
};

export function reducer(state = initialState, action: EventMonitoringActions): State {
  switch (action.type) {

    case EventMonitoringActionTypes.GetEventMonitorings:
      return {...state, Loaded: false, Loading: true};

    case EventMonitoringActionTypes.LoadEventMonitorings:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case EventMonitoringActionTypes.GetEventMonitoringsFail:
      return {...state, Loaded: true, Loading: false};

    default:
      return state;
  }
}
